import React from 'react';
import { Hero } from '../components/Hero';
import { ProductBreakdown } from '../components/ProductBreakdown';
import { Benefits } from '../components/Benefits';
import { Testimonials } from '../components/Testimonials';
import { CallToAction } from '../components/CallToAction';
import { CheckoutSection } from '../components/CheckoutSection';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-169">
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100" data-id="element-170">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between" data-id="element-171">
          <div className="font-serif font-bold text-xl text-red-800 flex items-center gap-2" data-id="element-172">
            <span data-id="element-173">🎭</span> MegaPackTeatro
          </div>
          <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-gray-600" data-id="element-174">
            <a href="#que-incluye" className="hover:text-red-700 transition-colors" data-id="element-175">
              Qué Incluye
            </a>
            <a href="#beneficios" className="hover:text-red-700 transition-colors" data-id="element-176">
              Beneficios
            </a>
            <a href="#testimonios" className="hover:text-red-700 transition-colors" data-id="element-177">
              Testimonios
            </a>
            <a href="#comprar" className="bg-red-700 text-white px-4 py-2 rounded-full hover:bg-red-800 transition-colors text-xs font-bold uppercase tracking-wide" data-id="element-178">
              Comprar
            </a>
          </nav>
        </div>
      </header>

      <main data-id="element-179">
        <Hero data-id="element-180" />
        <ProductBreakdown data-id="element-181" />
        <div id="beneficios" data-id="element-182">
          <Benefits data-id="element-183" />
        </div>
        <CheckoutSection data-id="element-184" />
        <div id="testimonios" data-id="element-185">
          <Testimonials data-id="element-186" />
        </div>
        <CallToAction data-id="element-187" />
      </main>

      <footer className="bg-gray-900 text-gray-400 py-12 border-t border-gray-800" data-id="element-188">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-189">
          <div className="text-center md:text-left" data-id="element-190">
            <h3 className="text-white font-serif font-bold text-lg mb-2" data-id="element-191">
              Mega Pack de Teatro
            </h3>
            <p className="text-sm" data-id="element-192">
              Recursos educativos para docentes apasionados.
            </p>
          </div>
          <div className="text-sm text-center md:text-right" data-id="element-193">
            <p data-id="element-194">
              &copy; {new Date().getFullYear()} Todos los derechos reservados.
            </p>
            <p className="mt-1" data-id="element-195">Hecho con ❤️ para la comunidad educativa.</p>
          </div>
        </div>
      </footer>
    </div>;
}